/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Partner_OverlineInputs */

const en_cp_partner_overline = /** @type {(inputs: Cp_Partner_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PARTNERSHIP`)
};

const id_cp_partner_overline = /** @type {(inputs: Cp_Partner_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KERJASAMA`)
};

/**
* | output |
* | --- |
* | "PARTNERSHIP" |
*
* @param {Cp_Partner_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_partner_overline = /** @type {((inputs?: Cp_Partner_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Partner_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_partner_overline(inputs)
	return en_cp_partner_overline(inputs)
});